<template>
  <v-card class="transparent" height="100%">
    <div class="ma-2 ma-sm-12 text-h5 font-weight-black _light_grey--text">{{ $t('statistics') }}</div>
    <v-row class="ma-2 ma-sm-12" justify="center">
      <v-col cols="12" md="auto">
        <v-card width="500" color="_light_grey" v-if="isShow('basicStatistics')">
          <v-card-title class="_grey--text font-weight-black">{{ $t('statistics') }}</v-card-title>
          <v-card-text class="ma-5 text-subtitle-1">
            <v-row>{{ $t('user') + ' ' + $t('total') + ' ' + userCount }}</v-row>
            <v-row>
              {{ $t('publishers') + ' ' + $t('total') + ' ' + publisherCount + ' (' + this.$t('include') + this.$t('consortium') + '9' + ')' }}
            </v-row>
            <v-row>{{ $t('application') + ' ' + $t('total') + ' ' + productList.length }}</v-row>
            <v-row>{{ $t('downloadCount') + ' ' + $t('total') + ' ' + installCount }}</v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card width="500" color="_light_grey" v-if="isShow('basicQuery')">
          <v-card-title class="_grey--text font-weight-black">{{ $t('accountQuery') }}</v-card-title>
          <v-card-text>
            <v-text-field v-model="searchUser" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details></v-text-field>
            <div>{{ userQueryResult }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card width="500" color="_light_grey" v-if="isShow('basicQuery')">
          <v-card-title class="_grey--text font-weight-black">{{ $t('departmentQuery') }}</v-card-title>
          <v-card-text>
            <v-text-field v-model="searchText" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details></v-text-field>
          </v-card-text>
          <v-data-table
            class="_light_grey"
            :headers="companyHeaders"
            :items="companyItem"
            :search="searchText"
            sort-by="department"
            dense
            width="100"
          >
            <v-progress-linear v-slot: progress color="blue" indeterminate></v-progress-linear>
            <template #item="props">
              <tr>
                <td>{{ props.item.department }}</td>
                <td>{{ props.item.count }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Db from '@/api/awsDb';

export default {
  name: 'Statistics',
  data: () => ({
    userCount: 0,
    appCount: 0,
    installCount: 0,
    userList: [],
    searchText: '',
    searchUser: '',
  }),
  computed: {
    ...mapGetters('dbTable', ['publisherList', 'productList', 'permissionId']),
    ...mapState('authenticate', ['userAttribute']),
    publisherCount() {
      const ary = [];
      this.publisherList.forEach((x) => {
        const temp2 = this.productList.filter((y) => y.publishers === x.id);
        if (temp2.length > 0) ary.push(x);
      });
      return ary.length;
    },
    userQueryResult() {
      if (this.searchUser === '') return '';
      const ary = this.userList.map((x) => ({ email: x.email, name: x.name }));
      const list = ary.filter((obj) => JSON.stringify(obj).indexOf(this.searchUser.trim()) !== -1);
      return list.length ? this.$t('exist') : this.$t('notExist');
    },
    companyHeaders() {
      return [
        { text: this.$t('department'), value: 'department', sortable: true },
        { text: this.$t('count'), value: 'count', sortable: false },
      ];
    },
    company() {
      return [...new Set(this.userList.map((x) => x.department))];
    },
    companyItem() {
      const ary = [];
      this.company.forEach((x) => {
        const total = this.userList.filter((y) => x === y.department);
        ary.push({ department: x, count: total.length });
      });
      return ary;
    },
  },
  created() {
    Db.scan('user', {}, ['email', 'name', 'department']).then((res) => {
      this.userList = res;
      this.userCount = res.length;
    });
    Db.scan('install', {}, ['id']).then((res) => {
      this.installCount = res.length;
    });
  },
  methods: {
    isShow(name) {
      if (!this.userAttribute.policy) return false;
      return Object.keys(this.userAttribute.policy).findIndex((x) => x === this.permissionId(name)) !== -1;
    },
  },
};
</script>
